import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {

  /** Version stored when the app first loads */
  private currentVersion: string | null = null;

  /** Emits true when a newer build is detected */
  hasNewVersion = false;

  constructor(private http: HttpClient) {}

  /**
   * Call once from AppComponent.ngOnInit().
   * @param pollIntervalMs  How often to check (default: every 5 min)
   */
  init(pollIntervalMs = 5 * 60 * 1000): void {
    // Record the version the user loaded with
    this.fetchVersion().subscribe(v => (this.currentVersion = v));

    // Poll periodically
    interval(pollIntervalMs)
      .pipe(switchMap(() => this.fetchVersion()))
      .subscribe(latest => {
        if (this.currentVersion && latest !== this.currentVersion) {
          this.hasNewVersion = true;
        }
      });
  }

  hardReload(): void {
    window.location.reload();
  }

  private fetchVersion() {
    // Cache-bust so the browser never serves a stale version.json
    return this.http
      .get<{ version: string }>(`/version.json?cb=${Date.now()}`)
      .pipe(
        map(res => res.version),
        catchError(() => of(this.currentVersion ?? ''))
      );
  }
}
